import { useMemo } from "react";
import { useCoachingSessionStore } from "../stores/coachingSessionStore";
import { useEphemeralCoachingWs } from "./useEphemeralCoachingWs";

/**
 * Hook for making coaching WebSocket requests.
 * Thin wrapper over the generic ephemeral WS hook.
 */
export function useCoachingRequest() {
  const processFrame = useCoachingSessionStore((s) => s.processFrame);
  const setActiveRequestId = useCoachingSessionStore((s) => s.setActiveRequestId);

  const callbacks = useMemo(
    () => ({ processFrame, setActiveRequestId }),
    [processFrame, setActiveRequestId],
  );

  const { sendAction, cancelRequest } = useEphemeralCoachingWs(callbacks);

  return { sendCoachingAction: sendAction, cancelRequest };
}
